









































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { ElForm } from 'element-ui/types/form';
import { SelectOptions } from 'modules/core/interfaces/selectOptions';
import AppMessage from 'modules/core/models/appMessage';
import { DeviceApi } from 'modules/devices/api/device';
import { AuthStateInterface } from 'modules/auth/interfaces/authState';
import { UserInterface } from 'modules/auth/interfaces/user';
import { ApiResponse } from 'modules/auth/interfaces/apiResponse';
import { Device } from '../classes/device';
import PhoneInput from 'modules/core/components/forms/PhoneInput.vue';

@Component({
  components: {
    PhoneInput,
  },
})
export default class Add extends Vue {
  public loading: boolean = false;
  public form: Device;
  public formRules!: any;
  public phoneModel = {
    phone: '',
    code: undefined,
  };
  private api: DeviceApi;

  constructor() {
    super();
    this.api = new DeviceApi();
    this.form = new Device();
  }

  public async created() {
    this.formRules = {
      Name: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      PhoneNumber: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if ((this.$refs.phoneInput as PhoneInput).validate()) {
              callback();
            } else {
              callback(new Error(this.$t('forms.wrongPhone') as string));
            }
          },
        },
      ],
    };
  }

  public goBack() {
    this.$router.go(-1);
  }

  public updatePhoneNumber(val: any) {
    this.form.PhoneNumber = val.code + val.phone;
    this.phoneModel = val;
  }

  public submitForm() {
    this.loading = true;
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        if (!this.form.DeviceGroupIds.includes('default')) {
          this.form.DeviceGroupIds.unshift('default');
        }

        this.api.add(this.form).then((status: boolean) => {
          AppMessage.show(this.$t('devices.add.success'), 'success');
          this.loading = false;
          this.$router.push('/devices');
        }).catch((error: any) => {
          this.loading = false;
        });
      } else {
        this.loading = false;
        return false;
      }
    });
  }
}
